module.exports = __webpack_public_path__ + "prod/1.42.2/img/chunshengcode.5cd40965.png";